import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { AlertTriangle, X } from "lucide-react";

const KEY = "bookit_banner_dismissed";

export default function ExpiryBanner() {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/platform/subscription/status");
      setInfo(data);
    } catch (err) {
      console.warn("Banner status fetch failed:", err?.message || err);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (!info) return;
    const k = `${KEY}:${info.status}:${Math.floor(info.days_remaining || 0)}`;
    setDismissed(window.localStorage.getItem(k) === "1");
  }, [info]);

  if (!info || dismissed) return null;
  const days = info.days_remaining;
  // Only show banner at 7d / 3d / 1d / 0d during trial or active; always for grace/expired
  const showThreshold = (info.status === "trial" || info.status === "active") && days != null && days <= 7;
  const isGrace = info.status === "grace";
  const isExpired = info.status === "expired";
  if (!showThreshold && !isGrace && !isExpired) return null;

  function dismiss() {
    const k = `${KEY}:${info.status}:${Math.floor(days || 0)}`;
    window.localStorage.setItem(k, "1");
    setDismissed(true);
  }

  const bgClass = isExpired ? "bg-red-50 border-red-200 text-red-900"
    : isGrace ? "bg-amber-50 border-amber-200 text-amber-900"
    : "bg-blue-50 border-blue-200 text-blue-900";

  const msg = isExpired
    ? "Tu suscripción venció. Renueva para reactivar tu panel."
    : isGrace
    ? `Periodo de gracia · ${days?.toFixed(0)} días para evitar bloqueo.`
    : info.status === "trial"
    ? `Trial: ${days?.toFixed(0)} día(s) restantes.`
    : `Tu suscripción vence en ${days?.toFixed(0)} día(s).`;

  return (
    <div className={`border-b ${bgClass}`} data-testid="expiry-banner">
      <div className="mx-auto max-w-7xl px-6 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm font-medium">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span>{msg}</span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => navigate("/admin/billing")} className="text-sm underline font-medium" data-testid="banner-renew-btn">
            Ir a billing
          </button>
          {!isExpired && (
            <button onClick={dismiss} className="opacity-60 hover:opacity-100" aria-label="Cerrar">
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
